<template>
    <div v-loading="loading" class="card-deal task-card-wrapper">
        <div class="card-deal-header caption-block">
            <div class="title">
                Карточка контакта
            </div>
            <div class="actions">
                <div class="btn btn-default orange action-edit" @click="edit" v-if="canEdit">
                    Редактировать
                </div>
                <div class="btn btn-default grey action-close" @click="close">
                    закрыть
                </div>
            </div>
        </div>
        <div class="tasks-wrapper mobile-wrapper">
            <div class="card contact-main-info task-main-info">
                <div class="row title">
                    <div class="value">
                        {{ contact.name }}
                    </div>
                </div>
                <div class="row">
                    <div class="label">
                        Телефон:
                    </div>
                    <div class="value" v-if="contact.contact_phones">
                        <div class="tel-item value" v-for="phone in contact.contact_phones" :key="phone.id">
                            {{ masker(phone.phone, '+# (###) ###-##-##', true, tokens) }}
                            <span class="icon-phone pointer pl10" @click="calltoPhone(phone.phone)">
                                <font-awesome-icon icon="phone" class="orange" title="Позвонить" />
                            </span>
                        </div>
                    </div>
                </div>
                <div class="row">
                    <div class="label">
                        E-mail:
                    </div>
                    <div class="value">
                        {{ contact.email }}
                    </div>
                </div>
                <div class="row">
                    <div class="label">
                        День рождения:
                    </div>
                    <div class="value">
                        {{ contact.birthday_date }}
                    </div>
                </div>
                <div class="row">
                    <div class="label">
                        Компания:
                    </div>
                    <div class="value">
                        {{ contact.company_name }}
                    </div>
                </div>
            </div>
            <div class="card task-comment">
                <div class="row task-item-row">
                    <div class="label">
                        Комментарий:
                    </div>
                </div>
                <div class="row task-item-comment">
                    <div class="value" v-format-text="contact.comment"></div>
                </div>
            </div>
        </div>
    </div>
</template>

<script>
import Card from './Card';
import { library } from '@fortawesome/fontawesome-svg-core';
import { faCheck } from '@fortawesome/free-solid-svg-icons';

library.add(faCheck);

export default {
    name: 'ContactsCardMobile',
    extends: Card
};
</script>
